"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_START_DATA_TOO_LARGE = void 0;
exports.appStartDataFits = appStartDataFits;
exports.appStartDataTooLargeMessage = appStartDataTooLargeMessage;
const database_identity_1 = require("@streamlain/database-identity");
const doc_sync_taxonomy_1 = require("@streamlain/doc-sync-taxonomy");
/**
 * The platform installs the start data of an App in write groups of at most
 * MAX_GROUP_DOCS documents, one table never split: a table fits when its
 * documents (root, directory parts, row shards) fit one group with the host
 * document of the App. There is no limit on the number of rows or tables;
 * the documents one table takes are the limit.
 */
function appStartDataFits(tableDocuments) {
    return tableDocuments + 1 <= doc_sync_taxonomy_1.MAX_GROUP_DOCS;
}
/** The code of the refusal of start data that do not fit one install. */
exports.APP_START_DATA_TOO_LARGE = 'APP_START_DATA_TOO_LARGE';
/**
 * The refusal of a table whose start data do not fit one write group.
 * `bytes` are those of its rows as the package carries them, the measure an
 * author controls; the row shards they take are about as large.
 */
function appStartDataTooLargeMessage(table, bytes) {
    const mib = (value) => (value / 1024 / 1024).toFixed(1);
    const capacity = (doc_sync_taxonomy_1.MAX_GROUP_DOCS - 2) * database_identity_1.DATABASE_ROW_SHARD_TARGET_BYTES;
    return `Start data of table ${table} are too large for one install (${mib(bytes)} MiB of at most ${mib(capacity)} MiB); import larger data after installing.`;
}
